var _excluded = ["title"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from 'react';
import { pure } from 'recompose';
import SvgIcon from "../../SvgIcon";
var SvgFlashFilled = function SvgFlashFilled(_ref) {
  var _ref$title = _ref.title,
    title = _ref$title === void 0 ? 'Filled Flash' : _ref$title,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement(SvgIcon, _extends({
    title: title
  }, props, {
    viewBox: "0 0 48 48"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M29.4594 0.000198364L27.1328 18.6126H40L18.5407 47.2251L20.8672 28.6126H8.00001L29.4594 0.000198364ZM23.1146 26.7579L23.1415 26.6045L21.4594 40.0002L21.8462 36.9055L23.1415 26.6045L26.5407 7.2251L23.1146 26.7579Z"
  }));
};
SvgFlashFilled = pure(SvgFlashFilled);
SvgFlashFilled.displayName = 'SvgFlashFilled';
export default SvgFlashFilled;